import { merge, mergeDeep } from '../../../../utils/state';
import { TYPES } from './actions';
import entity from './entity';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  organizations: {
    ...ReduxRestEntity.initialState,
    isUpdating: false,
  },
  marketing: ReduxRestEntity.initialState,
  subOrgMarketing: ReduxRestEntity.initialState,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.GET_ORG_REQUEST:
      return merge(state, {
        organizations: {
          ...state.organizations,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.GET_ORG_SUCCESS:
      return merge(state, {
        organizations: {
          isLoading: false,
          error: null,
          data: { ...state.organizations.data, ...action.payload },
        },
      });
    case TYPES.GET_ORG_FAILURE:
      return merge(state, {
        organizations: {
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.GET_ORG_ADMIN_DETAILS_REQUEST:
      return merge(state, {
        admin: {
          ...state.admin,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.GET_ORG_ADMIN_DETAILS_SUCCESS:
      return merge(state, {
        admin: {
          ...state.admin,
          isLoading: false,
          error: null,
          data: mergeDeep(state.admin.data, action.payload),
        },
      });
    case TYPES.GET_ORG_ADMIN_DETAILS_ERROR:
      return merge(state, {
        admin: {
          ...state.admin,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.GET_ORG_ADMIN_DOCUMENT_REQUEST:
      return merge(state, {
        document: {
          ...state.document,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.GET_ORG_ADMIN_DOCUMENT_SUCCESS:
      return merge(state, {
        document: {
          ...state.document,
          isLoading: false,
          error: null,
          data: mergeDeep(state.document.data, action.payload),
        },
      });
    case TYPES.GET_ORG_ADMIN_DOCUMENT_ERROR:
      return merge(state, {
        document: {
          ...state.document,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.CLEAR_ORG_ADMIN_DOCUMENT:
      return merge(state, {
        document: {
          isLoading: false,
          error: null,
          data: [],
        },
      });
    case TYPES.EDIT_ORG_ADMIN_DETAILS_REQUEST:
      return merge(state, {
        admin: {
          ...state.admin,
          isUpdating: true,
          error: null,
        },
      });
    case TYPES.EDIT_ORG_ADMIN_DETAILS_SUCCESS:
      return merge(state, {
        admin: {
          ...state.admin,
          isUpdating: false,
          error: null,
          data: mergeDeep(state.admin.data, action.payload),
        },
      });
    case TYPES.EDIT_ORG_ADMIN_DETAILS_ERROR:
      return merge(state, {
        admin: {
          ...state.admin,
          isUpdating: false,
          error: action.payload,
        },
      });
    case TYPES.GET_ORG_ASSETS_DETAILS_REQUEST:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: true,
          error: null,
          data: {},
        },
      });
    case TYPES.GET_ORG_ASSETS_DETAILS_SUCCESS:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: false,
          error: null,
          data: mergeDeep(state.marketing.data, action.payload),
        },
      });
    case TYPES.GET_ORG_ASSETS_DETAILS_ERROR:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.GET_SUB_ORG_ASSETS_REQUEST:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: true,
          error: null,
          data: {},
        },
      });
    case TYPES.GET_SUB_ORG_ASSETS_SUCCESS:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: false,
          error: null,
          data: mergeDeep(state.subOrgMarketing.data, action.payload),
        },
      });
    case TYPES.GET_SUB_ORG_ASSETS_ERROR:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.CREATE_ORG_ASSETS_REQUEST:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.CREATE_ORG_ASSETS_SUCCESS:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: false,
          error: null,
        },
      });
    case TYPES.CREATE_ORG_ASSETS_ERROR:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.CREATE_SUB_ORG_ASSETS_REQUEST:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.CREATE_SUB_ORG_ASSETS_SUCCESS:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: false,
          error: null,
        },
      });
    case TYPES.CREATE_SUB_ORG_ASSETS_ERROR:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.EDIT_ORG_ASSETS_REQUEST:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.EDIT_ORG_ASSETS_SUCCESS:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: false,
          error: null,
        },
      });
    case TYPES.EDIT_ORG_ASSETS_ERROR:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.EDIT_SUB_ORG_ASSETS_REQUEST:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.EDIT_SUB_ORG_ASSETS_SUCCESS:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: false,
          error: null,
        },
      });
    case TYPES.EDIT_SUB_ORG_ASSETS_ERROR:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.DELETE_ORG_ASSETS_REQUEST:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.DELETE_ORG_ASSETS_SUCCESS:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: false,
          error: null,
        },
      });
    case TYPES.DELETE_ORG_ASSETS_ERROR:
      return merge(state, {
        marketing: {
          ...state.marketing,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.DELETE_SUB_ORG_ASSETS_REQUEST:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: true,
          error: null,
        },
      });
    case TYPES.DELETE_SUB_ORG_ASSETS_SUCCESS:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: false,
          error: null,
        },
      });
    case TYPES.DELETE_SUB_ORG_ASSETS_ERROR:
      return merge(state, {
        subOrgMarketing: {
          ...state.subOrgMarketing,
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.EDIT_ORG_DETAILS_REQUEST:
      return merge(state, {
        organizations: {
          ...state.organizations,
          isUpdating: true,
          error: null,
        },
      });
    case TYPES.EDIT_ORG_DETAILS_SUCCESS:
      return merge(state, {
        organizations: {
          ...state.organizations,
          isUpdating: false,
          error: null,
          data: mergeDeep(state.organizations.data, action.payload),
        },
      });
    case TYPES.EDIT_ORG_DETAILS_ERROR:
      return merge(state, {
        organizations: {
          ...state.organizations,
          isUpdating: false,
          error: action.payload,
        },
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
